<template>
    <div v-if="googleLoaded && appLoaded">
        <GmapMarker
           :icon="icon"
            :position="{lat: parseFloat(location.latitude || location.lat), lng: parseFloat(location.longitude || location.lng)}"
            :clickable="true"
            :draggable="false"
            @click="markerClicked()"
        />
        <GmapInfoWindow
            :opened="false"
            :position="{lat: parseFloat(location.latitude || location.lat), lng: parseFloat(location.longitude || location.lng)}"
            :options="{
                pixelOffset: pixelOffset || {
                    width: 0,
                    height: -40
                }
            }"
            @closeclick="markerClicked()"
        >
        <p v-if="location.id">
            {{formatAptNum(location)}} {{location.addressComponents.streetNumber.shortName}} {{location.addressComponents.streetName.shortName}}, <br/> {{location.addressComponents.locality.shortName}} {{location.addressComponents.postalCode.shortName}}
            {{location.phone}}
        </p>
        </GmapInfoWindow>
    </div>
</template>

<script>
import Formatter from '@/utils/Formatter';
import mapsMixin from '@/components/mixins/mapsMixin';
import EventBus from '@EventBus';

export default {
    mixins: [
		mapsMixin
	],
	props: [
		"location",
		"focusedLocationBase",
		"icon",
		"pixelOffset"
	],
	methods: {
		formatAptNum: Formatter.formatAptNum,
		markerClicked() {
			EventBus.$emit('location-marker-clicked', this.location);
			this.$emit('click');
		}
	},
}
</script>



// WEBPACK FOOTER //
// src/components/store-locator/GoogleMarkerInfoWindow.vue